import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, RoutesRecognized } from '@angular/router';
import { Title } from '@angular/platform-browser';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { OverlayService } from './services/overlay.service';
import { routerTransition } from './services/animations/router.animation';
import { LeaveReviewComponent } from './modals/leave-review.component';
import { Subscription } from 'rxjs';
import { PromotionService } from './services/promotion.service';

@Component({
	selector: 'get-above-app',
	templateUrl: './app.component.html',
	animations: [routerTransition]
})

export class AppComponent implements OnInit, OnDestroy {

	@ViewChild('username') username: ElementRef
	@ViewChild('password') password: ElementRef

	overlaySubscription: Subscription
	promotionSubscription: Subscription
	promotionChanged: Subscription
	showPromotion: boolean = (window.localStorage.getItem('promotion-closed')) == null ? true : false

	componentData: any;
	// Template Variables

	isAuthenticated: Boolean = (window.location.href.indexOf('staging') !== -1) ? false: true
	errMessage: any;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private title: Title,
		private overlayService: OverlayService,
		private promotionService: PromotionService
	) {
		this.router.events.filter((event) => event instanceof NavigationEnd).map(() => this.activatedRoute).map((route) => {
			while (route.firstChild) route = route.firstChild;
			return route;
		}).filter((route) => route.outlet === 'primary').mergeMap((route) => route.data).subscribe((event) => {
			if (event['title']) {
				this.title.setTitle(event['title']);
			}
		});
		this.router.events.filter(event => event instanceof RoutesRecognized).pairwise().subscribe((e: any[]) => {
			localStorage.setItem('previousUrl', e[0].urlAfterRedirects)
		})
	}

	ngOnInit() {
		if (window.location.href.indexOf('staging') !== -1) {
			this.stagingLock()
		}

        this.overlaySubscription = this.overlayService.overlayData.subscribe(overlayData => {
            let component: any = null;
            if (overlayData && overlayData.component) {
                switch (overlayData.component) {
					case 'LeaveReviewComponent':
						component = LeaveReviewComponent;
                        break;
                }
                this.componentData = {
                    component: component,
                    inputs: overlayData.inputs || {}
                }
            } else {
                this.componentData = null;
            }
		});

		this.promotionSubscription = this.promotionService.promoMessageClosed.subscribe((message: string) => {
			if (message === 'promotion message closed') {
				this.showPromotion = false
			}
		})

		this.promotionChanged = this.promotionService.promoMessageChanged.subscribe((res: any) => {
			if (res[0].msg === 'Details updated successfully') {
				const promoObj = res[0].obj.content
				if (promoObj.displayPromotionStrip) {
					this.showPromotion = true
				} else {
					this.showPromotion = false
				}
			}
		})
	}

	ngOnDestroy() {
		this.overlaySubscription.unsubscribe()
		this.promotionSubscription.unsubscribe()
		this.promotionChanged.unsubscribe()
	}

	stagingLock() {
		let timeStr = localStorage.getItem('authTimestamp')
		if (!timeStr) {
			this.isAuthenticated = false
		} else {
			let time = parseInt(timeStr)
			let now = new Date().getTime()
			if (now > time) {
				this.isAuthenticated = false
			} else {
				this.isAuthenticated = true
			}
		}
	}

	authenticate() {
		let user = this.username.nativeElement.value
		let pass = this.password.nativeElement.value
		this.errMessage = null

		if (!user && !pass) {
			this.isAuthenticated = false
		}
		if (user === 'admin' && pass === 'Test@2019') {
			this.isAuthenticated = true
			const time = new Date().getTime() + (1000 * 60 * 60 * 24 * 1)
			const timeStr = JSON.stringify(time)
			localStorage.setItem('authTimestamp', timeStr)
			location.reload()
		} else {
			this.errMessage = 'invalid login details'
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts